import { render, staticRenderFns } from "./DOPaymentTarget.vue?vue&type=template&id=f5bedde4"
import script from "./DOPaymentTarget.vue?vue&type=script&lang=js"
export * from "./DOPaymentTarget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f5bedde4')) {
      api.createRecord('f5bedde4', component.options)
    } else {
      api.reload('f5bedde4', component.options)
    }
    module.hot.accept("./DOPaymentTarget.vue?vue&type=template&id=f5bedde4", function () {
      api.rerender('f5bedde4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/popup/DOPaymentTarget.vue"
export default component.exports